/**
 * Pagination data-hook props used for testing.
 */
/**
 * Pagination data-hook props used for testing.
 */
export enum DataHooks {
  currentPage = 'current-page',
  totalPages = 'total-pages',
  slashLabel = 'slash-label',
  pageCompact = 'page-compact',
  pageInputRoot = 'page-input-root',
  pageStrip = 'page-strip',
  pageStripRenderContainer = 'page-strip-render-container',
  pageInput = 'page-input',
  previous = 'previous',
  next = 'next',
  first = 'first',
  last = 'last',
  page = 'page',
}

export const HelperIds = {
  navButtonNext: 'navButtonNext',
  navButtonPrevious: 'navButtonPrevious',
  navButtonFirst: 'navButtonFirst',
  navButtonLast: 'navButtonLast',
  pageStrip: 'pageStrip',
  pageInput: 'pageInput',
  totalPages: 'totalPages',
  slash: 'slash',
  currentPage: 'currentPage',
  pageCompact: 'pageCompact',
};
